<template>
  <v-row class="pa-0 ma-0" align="center" justify="center">
    <v-btn absolute right bottom small fab color="white" @click.stop="onPrint()" class="print-btn"><v-icon>mdi-printer</v-icon></v-btn>
    <v-col cols="12" class="pa-0">
      <v-row class="pa-0 ma-0" align="center" justify="center">
        <v-col :cols="edit ? '9' : '12'" class="pa-0">
          <v-row class="pa-0 ma-0" align="center" justify="center">
            <v-col class="pa-0" align="center">
              <v-sheet tile :color=" getHeaderColor()" class="L-T">
                <span :class="getWeekColorClass(1)">日</span>
              </v-sheet>
            </v-col>
            <v-col cols="11" class="pa-0"  align="center">
              <v-row class="pa-0 ma-0" align="center" justify="center">
                <template v-for="x in 12">
                  <v-col cols="1" class="pa-0" align="center" :key="x">
                    <v-sheet tile :color="checkYear(mm, x) ? 'primary' :  getHeaderColor()" class="L-T">
                      <span :class="checkYear(mm, x) ? 'white--text' : getWeekColorClass(1)">{{ $MONTH[(x-1)] }}</span>
                    </v-sheet>
                  </v-col>
                </template>
              </v-row>
            </v-col>
            <v-col class="pa-0" align="center">
              <v-sheet tile :color=" getHeaderColor()" class="L-R-T">
                <span :class="getWeekColorClass(1)">日</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="pa-0" :hidden="!edit">
          <v-toolbar flat color="primary" height="22">
            <span class="white--text">雛形</span>
            <v-spacer></v-spacer>
            <v-btn rounded x-small depressed @click="onChangeCategory()"><span class="font-weight-bold primary--text">{{ menuSort == 'category' ? '時間' : '種別' }}</span></v-btn>
          </v-toolbar>
        </v-col>

        <v-col :cols="edit ? '9' : '12'" class="pa-0">
          <v-list
            class='pa-0 ma-0 overflow-y-auto'
            :style="contentsHeight"
          >
            <template v-for="i in 31">
              <v-row align="center" :key="i" class="pa-0 ma-0">
                <v-col class="pa-0" align="center">
                  <v-sheet tile :color="checkYear(dd, i) ? 'primary' :  getHeaderColor()" class="L-T" :height="height" :style="'padding-top: ' + ((height / 2) - ( 11 / 2) - 7) + 'px;'">
                    <span :class="checkYear(dd, i) ? 'white--text' : getWeekColorClass(1)" style="font-size: 11px;">{{ i }}</span>
                  </v-sheet>
                </v-col>
                <v-col cols="11" class="pa-0"  align="center">
                  <v-row class="pa-0 ma-0" align="center" justify="center">
                  <template v-for="x in 12">
                    <v-col cols="1" class="pa-0" align="center" :key="x">
                      <template v-if="checkDay(year, x, i)">
                        <v-row class="pa-0 ma-0" align="center" justify="center">
                          <v-col cols="2" class="pa-0 hidden-xs-only">
                            <v-sheet tile :color="getWeekColor(getWeek(i, x))" :height="height" :style="'padding-top: ' + ((height / 2) - ( 11 / 2) - 6) + 'px;'" class="L-T">
                              <span :class=" getWeekColorClass(getWeek(i, x))" style="font-size: 11px;">{{ $WEEK[getWeek(i, x)] }}</span>
                            </v-sheet>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.name == 'xs' ? '12' : '10'" class="pa-0">
                            <v-sheet
                              tile
                              :color="getWeekColor(getWeek(i, x))"
                              :height="height"
                              @dragover="dragover($event, x, i)"
                              @dragenter="dragenter($event, x, i)"
                              @drop="drop($event)"
                              @dragleave="dragleave($event)"
                              @click.right.stop="rClick($event, x, i)"
                              :style="checkLines(x, i)"
                              class="T"
                            >
                              <template v-for="item in getEvents(x, i)">
                                <v-row class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                                  <v-col cols="12" class="pa-0" align="center">
                                    <p
                                      v-if="item.type == 'holiday'"
                                      :style="getWidth(item)"
                                      class="mt-0 px-0">{{ item.title }}
                                    </p>
                                    <p
                                      v-else
                                      :style="getEventStyle(item)"
                                      draggable="true"
                                      @dragstart="dragstart($event, item)"
                                      @dragend="dragend($event)"
                                      class="mt-0 px-0"
                                      @click="onEditEvent(item)"
                                    >
                                      {{ item.duration == 1 ? item.title : '⬇︎' + item.title }}
                                    </p>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row class="pa-0 ma-0" align="center" justify="center">
                          <v-col cols="2" class="pa-0 hidden-xs-only">
                            <v-sheet tile :color="'white'" :height="height" :style="'padding-top: ' + ((height / 2) - ( 11 / 2) - 6) + 'px;'" class="L-T">
                              <span :class=" getWeekColorClass(getWeek(i, x))" style="font-size: 11px;"></span>
                            </v-sheet>
                          </v-col>
                          <v-col :cols="$vuetify.breakpoint.name == 'xs' ? '12' : '10'" class="pa-0">
                            <v-sheet
                              tile
                              :color="'white'"
                              :height="height"
                              :style="checkLines(x, i)"
                              class="T"
                            >
                              <template v-for="item in getEvents(x, i)">
                                <v-row class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                                  <v-col cols="12" class="pa-0" align="center">
                                    <p
                                      v-if="item.type == 'holiday'"
                                      :style="getWidth(item)"
                                      class="mt-0 px-0">
                                    </p>
                                    <p
                                      v-else
                                      :style="getEventStyle(item)"
                                      class="mt-0 px-0"
                                    >
                                    </p>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </template>
                    </v-col>
                  </template>
                  </v-row>
                </v-col>
                <v-col class="pa-0" align="center">
                  <v-sheet tile :color="checkYear(dd, i) ? 'primary' :  getHeaderColor()" class="L-R-T" :height="height" :style="'padding-top: ' + ((height / 2) - ( 11 / 2) - 7) + 'px;'">
                    <span :class="checkYear(dd, i) ? 'white--text' : getWeekColorClass(1)" style="font-size: 11px;">{{ i }}</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </template>
          </v-list>
        </v-col>
        <v-col cols="3" class="pa-0" :hidden="!edit">
          <v-sheet
            class='overflow-y-auto not-select'
            :style="contentsHeight"
          >
            <template v-if="menuSort == 'category'">
              <template v-for="description in descriptions">
                <v-row class="pa-0 ma-0" align="center" justify="center" :key="description.key">
                  <v-col cols="12" class="pa-1">
                    <v-toolbar flat :color="description.color" dark height="28">
                      <v-toolbar-title class="text-left">
                        <span>{{ description.name }}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn dark small icon @click.stop.prevent="description.value = !description.value">
                        <v-icon v-if="description.value">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </v-col>
                  <v-col cols="12" class="py-0" align="center">
                    <v-list v-if="description.value" color="transparent">
                      <template v-for="item in eventTemplates">
                        <v-row v-if="checkTemplateCategory(description.key, item)" class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                          <v-col cols="12" class="pa-0" align="center">
                              <div
                                draggable="true"
                                @dragstart="dragstart($event, item)"
                                @dragend="dragend($event)"
                              >
                              <v-row class="pa-0 ma-0" align="center" justify="center">
                                <v-col cols="8" class="pa-0">
                                  <p
                                    :style="getEventWidth(item)"
                                    class="task text-left"
                                    :color="getCategoryColor(item)">
                                    <span>{{ item.period == 1 ? item.title : '⬇︎' + item.title }}</span>
                                  </p>
                                </v-col>
                                <v-col cols="2" class="pa-0">
                                  <p class="task" :style="getEventWidth(item)">{{ $MONTHS1[item.month - 1]}}</p>
                                </v-col>
                                <v-col cols="2" class="pa-0">
                                  <p class="task" :style="getEventWidth(item)">{{ $WEEK_TABLE[item.week - 1].name }}</p>
                                </v-col>
                              </v-row>
                              </div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </template>
            <template v-else>
              <template v-for="x in 12">
                <v-row class="pa-0 ma-0" align="center" justify="center" :key="x">
                  <v-col cols="12" class="pa-1">
                    <v-toolbar flat height="28" color="grey" :key="x">
                      <v-toolbar-title class="text-left white--text">
                        <span>{{ $MONTHS4_TABLE[x - 1].name }}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-col>
                  <v-col cols="12" class="py-0" align="center">
                    <v-list dense :key="x + 'templates'">
                      <template v-for="item in eventTemplates">
                        <v-row v-if="checkTemplateDay(x, item)" class="pa-0 ma-0" align="center" justify="center" :key="item.key">
                          <v-col cols="12" class="pa-0" align="center">
                            <div
                              draggable="true"
                              @dragstart="dragstart($event, item)"
                              @dragend="dragend($event)"
                            >
                              <v-row class="pa-0 ma-0" align="center" justify="center">
                                <v-col cols="9" class="pa-0">
                                  <p
                                    :style="getEventWidth(item)"
                                    class="task text-left"
                                    :color="getCategoryColor(item)">
                                    <span>{{ item.period == 1 ? item.title : '⬇︎' + item.title }}</span>
                                  </p>
                                </v-col>
                                <v-col cols="3" class="pa-0">
                                  <p class="task" :style="getEventWidth(item)">{{ $WEEK_TABLE[item.week - 1].name }}</p>
                                </v-col>
                              </v-row>
                            </div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </template>
          </v-sheet>
        </v-col>

        <v-col :cols="edit ? '9' : '12'" class="pa-0">
          <v-row class="pa-0 ma-0" align="center" justify="center">
            <v-col class="pa-0" align="center">
              <v-sheet tile :color=" getHeaderColor()" class="L-T-B">
                <span :class="getWeekColorClass(1)">日</span>
              </v-sheet>
            </v-col>
            <v-col cols="11" class="pa-0"  align="center">
              <v-row class="pa-0 ma-0" align="center" justify="center">
                <template v-for="x in 12">
                  <v-col cols="1" class="pa-0" align="center" :key="x">
                    <v-sheet tile :color="checkYear(mm, x) ? 'primary' :  getHeaderColor()" class="L-T-B">
                      <span :class="checkYear(mm, x) ? 'white--text' : getWeekColorClass(1)">{{ $MONTH[(x-1)] }}</span>
                    </v-sheet>
                  </v-col>
                </template>
              </v-row>
            </v-col>
            <v-col class="pa-0" align="center">
              <v-sheet tile :color=" getHeaderColor()" class="L-R-T-B">
                <span :class="getWeekColorClass(1)">日</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="pa-0" :hidden="!edit">
        </v-col>
      </v-row>
    </v-col>

    <div>
      <v-dialog v-model="eventDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-event-dialog
          v-if="eventDialog"
          @dismissed="onDismissed"
          :dialog='eventDialog'
          :item="item"
          :group="group"
          :tempGroups="tempGroups"
          :year="year"
          :events="events"
          :eventTemplates="eventTemplates"
          type="new"
        >
        </app-event-dialog>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='rClickDialog'
          persistent
          max-width="400px">
          <app-event-add
            v-if="rClickDialog"
            @dismissed="onDismissed"
            :year="year"
            :item="revent"
            :group="group"
            :dialog='rClickDialog'
            :event="'add'"
          >
          </app-event-add>
        </v-dialog>
      </v-layout>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='templateDialog'
          persistent
          :max-width="'400'">
          <app-event-edit
            v-if="templateDialog"
            @dismissed="onDismissed"
            :item="item"
            :dialog='templateDialog'
            :event="event"
          >
          </app-event-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    }),
    thisMonth () {
      var m = new Date().getMonth()
      if (m < 4) {
        m += 9
      }
      return m
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 23 - 24 - 40) + 'px;'
    }
  },
  data () {
    return {
      height: 70,
      mm: 0,
      dd: 0,
      school: null,
      dragitem: null,
      dragto: null,
      templateDialog: false,
      editDialog: false,
      rClickDialog: false,
      templateItem: null,
      descriptions: [],
      eventDialog: false,
      event: null,
      item: null,
      loading: false,
      menuItems: [
        { title: '種別順', value: 'category' },
        { title: '時間順', value: 'time' }
      ],
      menuSort: 'time',
      revent: {}
    }
  },
  props: [ 'edit', 'year', 'group', 'tempGroups', 'add', 'events', 'eventTemplates', 'lines', 'type' ],
  watch: {
    add () {
      if (this.add) {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
      } else {
        this.item = null
      }
      this.eventDialog = this.add
    },
    windowSize () {
      this.height = (this.windowSize.y - 60 - 60 - 25 - 25 - 40) / 31
    }
  },
  created () {
    this.height = (this.windowSize.y - 60 - 60 - 25 - 25 - 40) / 31
    this.wait()
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
    this.dd = moment().date()
    var keys = Object.keys(this.data.schools)
    for (var i in keys) {
      if (this.data.schools[keys[i]]) {
        var index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
        }
      }
    }
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
  },
  methods: {
    async wait () {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(100).then(() => {
        this.loading = false
      })
    },
    checkYear (dd, i) {
      if (this.year !== this.getFY()) {
        return false
      }
      return dd === i
    },
    rClick (e, x, i) {
      e.preventDefault()
      if (this.getPrivilegesLevel(this.data) > 2) {
        return
      }
      if (this.year === this.getFY()) {
        var year = x > 9 ? parseInt(this.year) + 1 : this.year
        var mm = ('00' + (x > 9 ? x - 9 : x + 3)).slice(-2)
        var dd = ('00' + i).slice(-2)
        var date = year + '-' + mm + '-' + dd
        moment.tz.setDefault('Asia/Tokyo')
        var start = moment(date, 'YYYY-MM-DD')
        var end = moment(date, 'YYYY-MM-DD')

        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
        this.item.schools[this.school.key] = true
        this.item.startDate = start.format('YYYY-MM-DD')
        this.item.start = {
          date: start.format('YYYY-MM-DD'),
          yyyy: parseInt(start.format('YYYY')),
          mm: parseInt(start.format('MM')),
          dd: parseInt(start.format('DD'))
        }
        this.item.endDate = end.format('YYYY-MM-DD')
        this.item.end = {
          date: end.format('YYYY-MM-DD'),
          yyyy: parseInt(end.format('YYYY')),
          mm: parseInt(end.format('MM')),
          dd: parseInt(end.format('DD'))
        }
        this.event = 'event'
        this.templateDialog = true
      }
    },
    dragstart (e, item) {
      this.dragitem = JSON.parse(JSON.stringify(item))
      this.dragto = null
      e.target.style.opacity = 0.5
    },
    drop (e) {
      e.target.style.opacity = 1
      var item = null
      var year = this.dragto.mm > 9 ? parseInt(this.year) + 1 : this.year
      var mm = this.dragto.mm > 9 ? this.dragto.mm - 9 : this.dragto.mm + 3
      var date = year + '-' + mm + '-' + this.dragto.dd
      moment.tz.setDefault('Asia/Tokyo')
      var start = moment(date, 'YYYY-MM-DD')
      var end = moment(date, 'YYYY-MM-DD')
      if (this.dragitem.type === 'event') {
        item = JSON.parse(JSON.stringify(this.dragitem))
        if (this.dragitem.duration !== 1) {
          end.add(this.dragitem.duration, 'days')
        }
        item.duration = this.dragitem.duration
      } else {
        item = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
        item.template = this.dragitem.key
        if (this.dragitem.period !== 1) {
          end.add(this.dragitem.period, 'days')
        }
        item.duration = this.dragitem.period
      }
      item.startDate = start.format('YYYY-MM-DD')
      item.start = {
        date: start.format('YYYY-MM-DD'),
        yyyy: parseInt(start.format('YYYY')),
        mm: parseInt(start.format('MM')),
        dd: parseInt(start.format('DD'))
      }
      item.endDate = end.format('YYYY-MM-DD')
      item.end = {
        date: end.format('YYYY-MM-DD'),
        yyyy: parseInt(end.format('YYYY')),
        mm: parseInt(end.format('MM')),
        dd: parseInt(end.format('DD'))
      }
      item.charge = this.user.uid
      item.schools[this.school.key] = true
      this.storeEvent(item)
      this.dragitem = null
      this.dragto = null
      e.stopPropagation()
      e.preventDefault()
    },
    dragend (e) {
      e.target.style.opacity = 1.0
      e.preventDefault()
      this.dragitem = this.dragto = null
    },
    dragover (e, x, i) {
      e.preventDefault()
      this.dragto = { mm: x, dd: i }
    },
    dragenter (e, x, i) {
      e.preventDefault()
      e.target.style.opacity = 0.5
    },
    dragleave (e) {
      e.preventDefault()
      e.target.style.opacity = 1
    },
    checkTemplateDay (x, item) {
      if (parseInt(this.$MONTH[x - 1]) === item.month) {
        return true
      }
      return false
    },
    checkTemplateCategory (key, item) {
      if (item.category === key) {
        return true
      }
      return false
    },
    checkLines (mm, dd) {
      if (this.lines[mm - 1][dd - 1].length !== 0) {
        return 'border-left: 1px solid ' + this.getDescriptionColor(this.lines[mm - 1][dd - 1][0]) + ' !important; overflow-x: hidden; overflow-y: scroll;'
      }
      return 'overflow-x: hidden; overflow-y: scroll;'
    },
    getEventWidth (item) {
      var s = ''
      s += ' font-size: 12px; height: 18px; cursor: pointer;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getEventStyle (item) {
      var value = 0
      var s = ''
      value = this.windowSize.x * 0.05 * (this.edit ? 0.75 : 1)
      s = 'width: ' + value.toString() + 'px; height: 12px;'
      s += ' font-size:9px; cursor: pointer; padding-left: 2px !important; padding-right: 2px !important;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getWidth (item) {
      if (typeof item === 'undefined') {
        return ''
      }
      var value = 0
      var s = ''
      value = this.windowSize.x * 0.05 * (this.edit ? 0.75 : 1)
      s = 'width: ' + value.toString() + 'px; height: 12px;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      s += ' font-size:9px; padding-left: 2px !important; padding-right: 2px !important;'
      return s
    },
    getWeek (dd, mm) {
      var year = parseInt(JSON.parse(JSON.stringify(this.year)))
      var m = mm + 3
      if (m > 12) {
        m -= 12
        year += 1
      }
      var d = String(year) + '-' + ('0' + (m)).slice(-2) + '-' + ('0' + (dd)).slice(-2) + 'T02:00:00+09:00'
      return new Date(d).getDay()
    },
    getEvents (mm, dd) {
      var events = []
      for (var i in this.events[mm - 1][dd - 1]) {
        var event = JSON.parse(JSON.stringify(this.events[mm - 1][dd - 1][i]))
        if (event.type === 'event') {
          if (event.groups['*']) {
            events.push(event)
          } else if (event.groups[this.group]) {
            events.push(event)
          }
        } else {
          events.push(event)
        }
      }
      return events
    },
    back () {
      this.y = true
    },
    forward () {
      this.y = false
    },
    onPrint () {
      window.print()
    },
    onChangeCategory () {
      this.menuSort = this.menuSort === 'category' ? 'time' : 'category'
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onEditEvent (item) {
      if (this.type && this.type === 'dialog') {
        this.$emit('change', { item: JSON.parse(JSON.stringify(item)) })
      } else {
        this.item = JSON.parse(JSON.stringify(item))
        this.templateDialog = true
        this.event = 'event'
      }
    },
    onDismissed () {
      if (this.templateDialog) {
        this.templateDialog = false
        return
      }
      if (this.eventDialog) {
        this.eventDialog = false
      }
      this.$emit('dismissed')
    },
    storeEvent (item) {
      var vm = this
      vm.loading = true
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(item))
        if (item.key) {
          payload.updatedAt = parseInt(new Date().getTime())
        } else {
          payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        }
        vm.$store.dispatch('scheduleEvents/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>

.v-content {
 overflow-y: scroll;
}

p.task {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  line-height: 18px;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: aqua;
  border-radius: 8px;
  padding-left: 6px;
  margin: 2px;
  line-height: 12px;
  color: aliceblue;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

span {
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

.not-select {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

</style>
